import getHelper from '../../../../services/getHelper';
import UsersHelper from './teams/UsersHelper';

export default getHelper('/teams/:id', {
  users: UsersHelper,
});
